import React from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from 'react-redux'
import {
    EditOutlined,
    SettingOutlined,
    ShopOutlined,
    QuestionCircleOutlined,
    LogoutOutlined,
    KeyOutlined
} from '@ant-design/icons';
import Icon from '../util-components/Icon';
import { useSelector, useDispatch } from 'react-redux'
import { AuthSelector, logoutUser, setShowModalChangePass } from '../../store/reducers/auth/auth'

const menuItem = [
    // {
    // 	title: "",
    // 	icon: EditOutlined ,
    // 	path: "/"
    // }
]
export const NavProfile = () => {
    const dispatch = useDispatch()
    const AuthSelectors = useSelector(AuthSelector)
    function getItem(label, key, icon, children, type, disabled) {
        return {
            key,
            icon,
            children,
            label,
            type,
            disabled
        };
    }

    const items = [
        getItem(<span className="font-weight-normal">Đổi mật khẩu</span>, 'TK-0001', <KeyOutlined />),
        getItem(<span className="font-weight-normal">Thoát</span>, 'Exit-0001', <LogoutOutlined />),
    ];
    const onClick = (e) => {
        if (e.key === 'TK-0001') {
            dispatch(setShowModalChangePass(true))
        }
        else if (e.key === 'Exit-0001') {
            dispatch(logoutUser())
        }
    };
    const profileImg = "/img/avatars/logo-white-sm.png";
    const profileMenu = (
        <div className="nav-profile nav-dropdown" >
            <div className="nav-profile-header">
                <div className="d-flex">
                    <Avatar size={45} src={profileImg} />
                    <div className="pl-3">
                        <h4 className="mb-0">{`${AuthSelectors.user?.userCode}`}</h4>
                        <span className="text-muted">An Việt Phát Papper</span>
                    </div>
                </div>
            </div>
            <div className="nav-profile-body" >
                <Menu
                    onClick={onClick}
                    items={items}
                    style={{ boxShadow: 'none', border: 'none !important' }}>
                </Menu>
            </div>
        </div>
    );
    return (
        <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
            <div>
                <Avatar src={profileImg} />
            </div>
        </Dropdown>
    );
}

export default NavProfile
